export default "__VITE_ASSET__Ds1XSV2q__"